@if (formControl()) {
<div class="text form-group">
  <mat-form-field class="form-field">
    <mat-label>{{meta().name}}</mat-label>
    <input matInput [readonly]="readonly() || meta().readonly" [placeholder]="meta().name" [formControl]="$any(formArray()?.at(arrayIndex() ?? 0) ?? formControl()!)">
    @if (formControl()?.value && !meta().readonly && !readonly()) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="onClear()">
        <mat-icon>close</mat-icon>
      </button>
    }
    @if (meta().info) {
      <mat-hint><strong>{{meta().info}}</strong></mat-hint>
    }
    @if (formControl()?.hasError('pattern') && !formControl()?.hasError('required')) {
      <mat-error>
        {{meta().name}} is invalid
      </mat-error>
    }
    @if (formControl()?.hasError('required')) {
      <mat-error>
        {{meta().name}} is <strong>required</strong>
      </mat-error>
    }
    @if (formControl()?.hasError('maxlength')) {
      <mat-error>
        Max length for {{meta().name}} is <strong>{{meta()?.maxLength}}</strong>
      </mat-error>
    }
    @if (formControl()?.errors?.form) {
      <mat-error>
        {{formError}}
      </mat-error>
    }
  </mat-form-field>
</div>
}
